import dynamic from 'next/dynamic';
export default {
  structured_data_header: dynamic(() => import( /* webpackChunkName: "blazePbStructuredData" */'./StructuredDataHeader'))
};
//# sourceMappingURL=index.js.map